// extracted by mini-css-extract-plugin
export default {"button":"Buttons__button--1gQ","demo":"Buttons__demo--3ap","play":"Buttons__play--2rf"};